<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.course.create')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">

                    <form @submit.prevent="createCourse()">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.course.create')}}</div>

                            <button class="btn btn-primary float-right">{{$t('button.save')}}</button>
                        </div>

                        <div class="card-body">

                            <div class="form-group row">
                                <label class="col-sm-3">{{$t('form.course.courseTitle')}}<span
                                        class="text-danger">*</span></label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model.trim="$v.course.CourseTitle.$model"
                                        :class="{ 'is-invalid': $v.course.CourseTitle.$error }">
                                    <div class="invalid-feedback" v-if="!$v.course.CourseTitle.required">
                                        {{$t('form.validation.required')}}</div>
                                    <div class="invalid-feedback" v-if="!$v.course.CourseTitle.maxLength">
                                        {{$t('form.validation.maxLength', {num: $v.course.CourseTitle.$params.maxLength.max})}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3" for="CourseCode">{{$t('form.course.courseCode')}}<span
                                        class="text-danger">*</span></label>
                                <div class="col-sm-9">
                                    <input id="CourseCode" maxlength="6" name="CourseCode" type="text"
                                        class="form-control" v-model.trim="$v.course.CourseCode.$model"
                                        :class="{ 'is-invalid': $v.course.CourseCode.$error }">
                                    <div class="invalid-feedback" v-if="!$v.course.CourseCode.required">
                                        {{$t('form.validation.required')}}</div>
                                    <div class="invalid-feedback" v-if="!$v.course.CourseCode.maxLength">
                                        {{$t('form.validation.maxLength', {num: $v.course.CourseCode.$params.maxLength.max})}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3" for="SBSCredits">{{$t('form.course.SBSCredits')}}<span
                                        class="text-danger">*</span></label>
                                <div class="col-sm-9">
                                    <input id="SBSCredits" name="SBSCredits" type="number" class="form-control"
                                        v-model.trim="$v.course.SBSCredits.$model"
                                        :class="{ 'is-invalid': $v.course.SBSCredits.$error }">
                                    <div class="invalid-feedback" v-if="!$v.course.SBSCredits.required">
                                        {{$t('form.validation.required')}}</div>
                                    <div class="invalid-feedback" v-if="!$v.course.SBSCredits.maxLength">
                                        {{$t('form.validation.maxLength', {num: $v.course.SBSCredits.$params.maxLength.max})}}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-3" for="ECTSCredits">{{$t('form.course.ECTSCredits')}}<span
                                        class="text-danger">*</span></label>
                                <div class="col-sm-9">
                                    <input id="ECTSCredits" type="number" class="form-control" name="ECTSCredits"
                                        v-model.trim="$v.course.ECTSCredits.$model"
                                        :class="{ 'is-invalid': $v.course.ECTSCredits.$error }">
                                    <div class="invalid-feedback" v-if="!$v.course.ECTSCredits.required">
                                        {{$t('form.validation.required')}}</div>
                                    <div class="invalid-feedback" v-if="!$v.course.ECTSCredits.maxLength">
                                        {{$t('form.validation.maxLength', {num: $v.course.ECTSCredits.$params.maxLength.max})}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        minLength,
        maxLength,
        decimal,
        alpha
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions'],

        data() {
            return {
                isLoading: false,
                fullPage: true,

                alert: false,
                alertClass: '',
                alertMessage: '',

                course: {
                    CourseTitle: null,
                    CourseCode: null,
                    ECTSCredits: null,
                    SBSCredits: null
                }
            }
        },

        validations: {
            course: {
                CourseTitle: {
                    required,
                    maxLength: maxLength(255)
                },
                CourseCode: {
                    required,
                    maxLength: maxLength(6)
                },
                ECTSCredits: {
                    required,
                    decimal,
                    maxLength: maxLength(4)
                },
                SBSCredits: {
                    required,
                    decimal,
                    maxLength: maxLength(4)
                }
            }
        },

        mounted() {
            if (!this.permissions.createCourses) {
                this.$router.push('/');
            }
        },

        methods: {

            createCourse() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                
                    let errorMsg = '';
                      if(this.$v.course.CourseTitle.$error){
                            errorMsg = 'Course Title';
                      }

                    if(this.$v.course.CourseCode.$error){
                            errorMsg = errorMsg ? errorMsg +", Course Code": "Course Code";
                      }

                    if(this.$v.course.ECTSCredits.$error){
                            errorMsg = errorMsg ? errorMsg +", ECTS Credits": "ECTS Credits";
                      }

                    if(this.$v.course.SBSCredits.$error){
                            errorMsg = errorMsg ? errorMsg +", SBS Credits": "SBS Credits";
                      }

                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return;
                }

                this.isLoading = true;

                let formData = new FormData();

                formData.append("course", JSON.stringify(this.course));

                axios
                    .post('/api/courses', formData)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        }

                        else if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'CourseIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
